import {
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	FocusLayer,
	LayerWrapper,
	ShimLayer,
	Text,
	TokenTextAppearance,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { CloseCircle, Close } from '@volkswagen-onehub/icons-core';
import './BrokenShareLinkModal.scss';

function BrokenShareLinkModal(props: Props) {
	const { toggleVisibility, t } = props;

	function closeModal() {
		toggleVisibility();
	}

	return (
		<ThemeProvider theme="main">
			<div className="alert-layer">
				<LayerWrapper contentCentered>
					<ShimLayer key="shim" />
					<FocusLayer size={'B'} active>
						<Container gutter={ContainerGutter.static400} padding={ContainerPadding.static450} wrap="always" stretchContent>
							<Container gutter={ContainerGutter.static300} wrap="always" horizontalAlign="flex-start">
								<div className="modalBodyItem">
									<Text appearance={TokenTextAppearance.headline500}>{t('shareLinkError.title')}</Text>
								</div>

								<div className="modalBodyItem errorIcon">
									<CloseCircle variant="large" />
								</div>

								<div className="modalBody">
									<Text>{t('shareLinkError.content')}</Text>
								</div>
								<div className="back-btn modalBodyItem">
									<CTA
										size="small"
										emphasis="secondary"
										aria-label={t('general.close')}
										onClick={() => closeModal()}
										tag="button"
										icon={<Close variant="small" aria-hidden={true} />}
									>
										{t('general.close')}
									</CTA>
								</div>
							</Container>
						</Container>
					</FocusLayer>
				</LayerWrapper>
			</div>
		</ThemeProvider>
	);
}

interface Props {
	toggleVisibility: () => void;
	t: any;
}

export default BrokenShareLinkModal;
